var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ActivityView',{attrs:{"app-state-store":_vm.appStateStore,"user-repository":_vm.userRepository,"activity-repository":_vm.activityRepository,"target-student-user-id":_vm.studentUserId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }